import {createApi, createApiClient, InitParam} from "@3dcalc/3dpClient";
import {setReady} from "../setting/initParam";

const client = createApiClient({
    apiUrl: 'https://3dpapi.deallog.pro/api/v1',
    // apiUrl: 'http://localhost:3300/api/v1',
    apiKey: '57426eaf100331499cf97eceb0021530cc9c0843561ebecb6a65a44a2b62b505',
    calculatorId: '1ea49d07-771c-4691-90dc-c8475d2a83df',
    onError: (error) => {
        console.error('API Error:', error);
    },
    onUnauthorized: () => {
        console.error('Unauthorized! Check your API key');
    }
});

const { config } = await client.init()
setReady(config as InitParam)

export const api = createApi(client);
